export enum TipoMenu {
  Home = 1,
  Checkup = 2,
  Mov = 3
}